import { computed, inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OktaAuthStateService } from '@okta/okta-angular';
import OktaAuth, { UserClaims } from '@okta/okta-auth-js';
import { environment } from '../../../environments/environment';
import { Observable, switchMap, from, EMPTY, tap, map,of } from 'rxjs';
import { PermissionType } from '../models/permission/permission-type-enum';
import { JwtUser } from '../models/jwt/jwt-user.model';
import { JwtTokens } from '../models/jwt/jwt-token.model';

@Injectable({
    providedIn: 'root'
})


export class OktaAuthService {
    public displayName: Signal<string | null> = signal(null)
    private oktaUser: WritableSignal<UserClaims | null> = signal(null);
    private permissions: WritableSignal<number[]> = signal(localStorage.getItem('permissions')?.split(',').map(p => parseInt(p, 10)) || []);
    private readonly oktaAuth = new OktaAuth(environment.okta);
    private readonly oktaAuthStateService = inject(OktaAuthStateService);
    private readonly httpClient = inject(HttpClient);

    constructor() {
        this.displayName = computed(() => this.oktaUser()?.name || null)
    }


    signout(): void {
        this.oktaAuth.signOut();
    }


    authorize(): Observable<JwtUser> {
        return this.oktaAuthStateService.authState$.pipe(
            switchMap(
                state => from(state.isAuthenticated ? this.oktaAuth.getUser() : EMPTY)
                    .pipe(
                        tap(user => this.oktaUser.set(user)),
                    )
            ),
            switchMap(
                () => this.getUserInfo()
            )
        )
    }


    // isAuthorized(expectedRole: PermissionType[]): boolean {
    //     const perm: PermissionType[] = localStorage.getItem('Permissions')?.split(',').map(p => parseInt(p, 10)) || [];
    //     return perm.some(r => expectedRole.includes(r));
    // }

    
    isAuthorized(expectedRole: PermissionType[]): Signal<boolean> {
        return computed(() => this.permissions().some(r => expectedRole.includes(r)))
    }

//for testing purposes only
    private getUserInfo(): Observable<JwtUser> {
        const jwtUser: JwtUser={
            uid: '12345',
            name: 'Test User',
            email: 'mariusz_pabisz@jabil.com',
            exp: 1,
            iss: 'local',
            roles: ['admin'],
        };
        return of(jwtUser);
        return this.httpClient.get<JwtTokens>(`${environment.urls.api}user/info`).pipe(
            map(t => this.parseJwt(t.jwtToken))
        )
    }


    private parseJwt(token: string): JwtUser {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => ('%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))).join(''))
        const user = JSON.parse(jsonPayload) as JwtUser;
        //this.user.set(user)
        //localStorage.setItem("jwt-token", token);
        // console.log(user)
        const permissions = user.permissions?.map(m => Number(m)) || [];
        this.permissions.set(permissions);
        localStorage.setItem("permissions", permissions.toString());
        return user;
    }

}


